// removed by extract-text-webpack-plugin
module.exports = {"jdHeaderFontColor":"#FF4C5D","jdBigFontColor":"#FD9031","jdNormalFontColor":"#5D9DFE","jdSmallFontColor":"#43CD3F","jdHeaderFontSize":"32px","jdBigFontSize":"24px","jdNormalFontSize":"18px","jdSmallFontSize":"14px","jdSelBackgroundColor":"yellow","jdBorderWhiteBackColor":"#B49159","jdBorderYellowBackColor":"#FFFFFF"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/variables.less
// module id = yk9U
// module chunks = 2